var map = {
	"./download_appstore_en.svg": 1069,
	"./download_appstore_pr.svg": 1070
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/download_appstore_.*\.svg$
// module id = 1268
// module chunks = 30